const BANK_ALIASES = {
  bankokbank: 'bankokbank',
  bangkokbank: 'bankokbank',
  bbl: 'bankokbank',
  kbank: 'kbank',
  kasikorn: 'kbank',
  kasikornbank: 'kbank',
  scb: 'scb',
  siamcommercialbank: 'scb',
  ktb: 'ktb',
  krungthai: 'ktb',
  krungthaibank: 'ktb',
  krungsri: 'krungsri',
  bay: 'krungsri',
  bankofayudhya: 'krungsri',
  ttb: 'ttb',
  tmb: 'ttb',
  gsb: 'gsb',
  governmentsavingsbank: 'gsb',
  baac: 'baac',
  ghb: 'ghbank',
  ghbank: 'ghbank',
  governmenthousingbank: 'ghbank',
  cimb: 'cimb',
  cimbthai: 'cimb',
  kiatnakin: 'kiatnakin',
  kkp: 'kiatnakin',
  uob: 'uob',
  lh: 'lh',
  lhbank: 'lh',
  tisco: 'tisco',
  icbc: 'icbc',
  standard: 'standard',
  standardchartered: 'standard',
  truewallet: 'truewallet',
  truemoney: 'truewallet',
  truemoneywallet: 'truewallet',
  'ทรูวอลเลท': 'truewallet',
  'ทรูมันนี่': 'truewallet',
  'ธนาคารอิสลาม': 'ธนาคารอิสลาม'
}

export function normalizePaymentBankCode (value) {
  const source = value && typeof value === 'object'
    ? (value.value || value.bank || value.bank_name || value.code)
    : value
  const normalized = String(source || '').trim().toLowerCase().replace(/[\s_-]+/g, '')
  return BANK_ALIASES[normalized] || normalized
}

export function parsePaymentBlockedBanks (value) {
  let values
  if (Array.isArray(value)) values = value
  else if (value && typeof value === 'object') values = Object.keys(value).filter(key => value[key])
  else values = String(value || '').split(',')

  return [...new Set(values.map(normalizePaymentBankCode).filter(Boolean))]
}

export function paymentBlockedBanksFromRecord (record) {
  if (!record) return []
  const source = record.payment_blocked_banks !== undefined
    ? record.payment_blocked_banks
    : (record.blocked_banks !== undefined ? record.blocked_banks : record.available)
  return parsePaymentBlockedBanks(source)
}

export function isPaymentBankBlocked (blockedBanks, account) {
  const bank = normalizePaymentBankCode(account && (account.bank || account.bank_name || account.value || account))
  return Boolean(bank && parsePaymentBlockedBanks(blockedBanks).includes(bank))
}
